export default {
    language: 'el-GR',
    navigation: 'Πίσω',
    home: {
        title: 'Υπολογιστής χρώματος',
        subtitle:
            'Θα σας βοηθήσουμε να επιλέξετε το καλύτερο αντιρρυπαντικό προϊόν για το σκάφος σας και να υπολογίσετε την ποσότητα που χρειάζεστε για τις ανάγκες σας',
        findProduct: 'βρείτε προϊόν',
        calculateVolume: 'υπολογίστε τον όγκο'
    },
    find: {
        questions: {
            type: '<strong>Τυπος</strong>σκαφους?',
            material: '<strong>Υλικό</strong>σκάφους?',
            sailFrequency: '<strong>Πόσο συχνά</strong> χρησιμοποιείτε το σκάφος σας?',
            paintLocation: '<strong>Πού</strong> βάφετε το σκάφος σας;?',
            waterType: 'In what <strong>type of water</strong> do you use your boat?'
        },
        answers: {
            help: 'Χρειάζεστε βοήθεια στην επιλογή του αντιρρυπαντικού?',

            type: [
                {
                    label: 'Ιστιοφόρο σκάφος',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Μηχανοκίνητο σκάφος',
                    sublabel: 'μέχρι 20 κόμβους',
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Μηχανοκίνητο σκάφος',
                    sublabel: 'ταχύτερη από 20 κόμβους',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'GRP',
                    value: 'plastic'
                },
                {
                    label: 'σίδερο',
                    value: 'iron'
                },
                {
                    label: 'Ξύλο',
                    value: 'wood'
                },
                {
                    label: 'Αλουμίνιο',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Σπάνια',
                    sublabel: '1-2 φορές τον μήνα ή λιγότερο',
                    value: 'low'
                },
                {
                    label: 'Συχνά',
                    sublabel: '1-2 φορές την εβδομάδα',
                    value: 'medium'
                },
                {
                    label: 'Πολύ συχνά',
                    sublabel: 'Σχεδόν καθημερινά',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Διάλεξε χώρα',
                    countries: [
                        { label: 'HB', value: 'en-GB' },
                        { label: 'Καναδάς', value: 'en-CA' },
                        { label: 'Δανία', value: 'da-DK' },
                        { label: 'Ισπανία', value: 'es-ES' },
                        { label: 'Φινλανδία', value: 'fi-FI' },
                        { label: 'Γερμανία', value: 'de-DE' },
                        { label: 'Ελλάδα', value: 'el-GR' },
                        { label: 'Κροατία', value: 'hr-HR' },
                        { label: 'Νορβηγία', value: 'nb-NO' },
                        { label: 'Ολλανδία', value: 'nl-NL' },
                        { label: 'Σουηδία - ανατολική ακτή', value: 'sv-SE_e' },
                        { label: 'Σουηδία - δυτική ακτή', value: 'sv-SE_w' },
                        { label: 'Σουηδία - Λίμνη', value: 'sv-SE_l' }
                    ]
                }
            ],
            waterType: [
                { label: 'Θάλασσα/ωκεανός', value: 'sea/ocean' },
                { label: 'Ποτάμι', value: 'rivers' },
                { label: 'Λίμνη', value: 'lakes' }
            ]
        },
        result: {
            heading: 'Συνιστούμε',
            selection: {
                title: 'Η επιλογή σας',
                type: 'Τύπος σκάφους',
                material: 'Υλικό σκάφους',
                sailFrequency: 'Δραστηριότητα',
                country: 'Χώρα'
            },
            category: {
                premium: 'Ασφάλιστρο',
                alternative: 'εναλλακτική λύση',
                bestBuy: 'Καλύτερη αγορά',
                economic: 'Economic',
                bestBuyAlternative: 'Καλύτερη αγορά εναλλακτική λύση',
                economicAlternative: 'Economic εναλλακτική λύση'
            },
            findOutMore: 'Βρείτε περισσότερα',
            whereToBuy: 'Σημεία πώλησης',
            email: 'Email',
            send: 'Aποστέλλω',
            feedback: {
                title: 'Ήταν χρήσιμες αυτές οι πληροφορίες?',
                yes: 'Ναί',
                no: 'όχι',
                comment: 'Σχόλιο',
                placeholder: 'Σχόλιο'
            },
            recommendation: {
                title: 'Αποστολή πρότασης μέσω e-mail'
            },
            calculateVolume: 'Υπολογίστε τον όγκο'
        }
    },
    calculate: {
        letsCalculate: 'Υπολογίζω',
        questions: {
            antifouling: 'Επιλέξτε υφαλοχρώματα',
            keelType: '<strong>Τύπος</strong>kαρίνας?',
            dimensions: '<strong>Διαστάσεις</strong> σκάφους'
        },
        answers: {
            keelType: [
                {
                    label: 'Καρίνα σε σχήμα πτερυγιού',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Καρίνα μεγάλου μήκους',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Μεμονωμένες διαστάσεις'
                },
                {
                    title: 'Ή υποθαλάσσια περιοχή σε m2'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Μονάδα',
                    values: [{ label: 'Μετρητές', value: 'm' }, { label: 'Feet', value: 'f' }],
                    valuesUS: [{ label: 'Feet', value: 'f' }, { label: 'Meters', value: 'm' }]
                },
                {
                    type: 'waterline',
                    label: 'Μήκος ισάλου γραμμής'
                },
                {
                    type: 'beam',
                    label: 'Πλάτος σκάφους'
                },
                {
                    type: 'draft',
                    label: 'Βύθισμα'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Προτεινόμενη ποσότητα',
            selection: {
                title: 'Η επιλογή σας',
                antifouling: 'Υφαλοχρώματα',
                type: 'Tυπος σκαφους',
                material: 'Υλικό σκάφους',
                sailFrequency: 'Δραστηριότητα',
                country: 'Χώρα',
                keelType: 'Τύπος καρίνας',
                dimensions: 'Διαστάσεις σκάφους'
            },
            category: {
                premium: 'Ασφάλιστρο',
                alternative: 'εναλλακτική λύση',
                bestBuy: 'Καλύτερη αγορά',
                economic: 'Economic',
                bestBuyAlternative: 'Καλύτερη αγορά εναλλακτική λύση',
                economicAlternative: 'Economic εναλλακτική λύση'
            },
            suggestedAmount: 'Προτεινόμενη ποσότητα',
            suggestedAmountTwoCoats: 'Προτεινόμενη ποσότητα (2 στρώσεις)',
            oneCoat: '(1 στρώση)',
            fiveCoats: '(5 στρώσεις)',

            primerAltTiecoatSilic:
                "Μην ξεχάσετε επίσης να χρησιμοποιήσετε τον Tiecoat",
            primerAltSilicSealSilic:
                '<strong>CASE 2</strong><br/>Εφαρμογή σε σκάφη με προηγούμενη επίστρωση πάνω από παλιά αντιρρυπαντικά σε καλή κατάσταση – εύκολη μετάβαση στο Silic One System',
            primerAlLightSilic:
                '<strong>CASE 1</strong><br/>εφαρμογή πλήρους συστήματος & nέο σκάφος ή χωρίς εποξειδικό',

            primerAltTiecoat: 'N’oubliez pas de toujours utilisé un Tiecoat!',
            primerAltSilicSeal:
                '<strong>CASE 1</strong><br/>Décapage de l’ancien antifouling et application du système complet',
            primerAlLight:
                '<strong>CASE 2</strong><br/>Application sur un ancien antifouling en bon état – passage facile à Silic One System',
            primer: 'Το σκάφος έχει σοβαρές ζημιές ή βάφεται για πρώτη φορά; Θα χρειαστείτε...',
            whereToBuy: 'Σημεία πώλησης',
            email: 'Email',
            send: 'Aποστέλλω',
            or: 'Ή',
            feedback: {
                title: 'Ήταν χρήσιμες αυτές οι πληροφορίες?',
                yes: 'Ναί',
                no: 'Οχι',
                comment: 'Σχόλιο',
                placeholder: 'Σχόλιο'
            },
            recommendation: {
                title: 'Αποστολή πρότασης μέσω e-mail'
            },
            calculateVolume: 'υπολογίστε τον όγκο'
        }
    },
    map: {
        country: 'Χώρα',
        city: 'Πόλη',
        getDirections: 'Λάβετε οδηγίες',
        placeholder: 'Όλες οι πόλεις...'
    },
    footer: 'Hempel Yacht - Όλα όσα χρειάζεται να γνωρίζετε για την βαφή του σκάφους'
}
